import { useProductFlowVersion } from '@/hooks/useProductFlowVersion';
import { AddProduct, AddProductV2 } from '@/routes/elements';

export default function AddProductRouter() {
  const { isV2 } = useProductFlowVersion();
  const AddProductPage = isV2 ? AddProductV2 : AddProduct;

  return <AddProductPage />;
}
